import { createSelector } from '@ngrx/store';
import { selectCoreState } from '../core-feature-selector';

const selectRedirectState = createSelector(
  selectCoreState,
  (state) => state.redirect,
);
export const selectRedirectPath = createSelector(
  selectRedirectState,
  (state) => state.redirectPath,
);
